import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { connect } from "react-redux";
import Layout from "./containers/Layout/Layout";
import Registration from "./components/authentication/Registration/Registration";
import RegistrationInvite from "./components/authentication/Registration/RegistrationInvite";
import VerifyEmail from "./components/authentication/VerifyEmail/VerifyEmail";
import LogoutRedirect from "./components/authentication/LogoutRedirect/LogoutRedirect";
import * as actions from "./store/actions/auth";
import './App.css';

class App extends Component {

  componentDidMount() {
    this.props.attemptSessionRestoration();

    // Listen for logout events from other account.allorado.io tabs
    window.addEventListener("storage", this.handleStorageEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.handleStorageEvent);
  }

  handleStorageEvent = (event) => {
    if (event.key === "account_logout") {
      // Another tab triggered a logout -> reflect it in this tab
      this.props.logout();
      return;
    }

    if (
      event.key === "account_login" ||
      event.key === "token" ||
      event.key === "username" ||
      event.key === "tokenExpiration"
    ) {
      // Another tab logged in or refreshed its session -> try to restore here too
      this.props.attemptSessionRestoration();
    }
  };

  render() {
    return (
      <div className="App">
        <Routes>
          <Route path="/register" element={<Registration />} />
          <Route path="/register-invite" element={<RegistrationInvite />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/logout" element={<LogoutRedirect />} />
          <Route path="/*" element={
            <Layout
              token={this.props.token}
              isAuthenticated={this.props.isAuthenticated}
              username={this.props.username}
              email={this.props.email}
              logout={this.props.logout}
            />
          } />
        </Routes>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    isAuthenticated: state.auth.token !== null,
    username: state.auth.username,
    email: state.auth.email
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    attemptSessionRestoration: () => dispatch(actions.attemptSessionRestoration()),
    logout: () => dispatch(actions.logout())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);